// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lHd0F5 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  padding: var(--spacing-2);
  border-radius: var(--radius-s);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  background-color: var(--surface-neutral-pale);
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  width: 100%;
}

.lHd0F5:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: 2px;
}

.lHd0F5.ml9RUS {
  background-color: var(--surface-primary-subtle);
}

.lHd0F5:disabled,
.lHd0F5.nXShoN {
  cursor: not-allowed;
  background-color: var(--surface-neutral-pale);
}

.lHd0F5:hover:not(.ml9RUS):not(.nXShoN) {
  background-color: var(--surface-primary-subtle);
}

.csSp_z {
  width: var(--spacing-2);
  height: var(--spacing-2);
  border: 1px solid var(--icon-neutral-dark);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: var(--spacing-0-5);
}

.ml9RUS .csSp_z {
  border-color: var(--surface-primary-medium);
  background-color: var(--surface-primary-medium);
}

.h_O154 {
  width: 6px;
  height: 6px;
  background-color: var(--surface-neutral-white);
  border-radius: 50%;
}

.UilNtv {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.HPKBW7 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: 24px;
  color: var(--text-neutral-dark);
  margin: 0;
}

.nXShoN .HPKBW7 {
  color: var(--disabled-subtle-text);
}

.Sc4kYh {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: 16px;
  color: var(--text-neutral-dark);
  margin: 0;
}

.nXShoN .Sc4kYh {
  color: var(--disabled-subtle-text);
}

.nXShoN .iV92mG {
  opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/RechargePaymentPage/components/PaymentMethodOption/PaymentMethodOption.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,6CAA6C;EAC7C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".paymentOption {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-2);\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n  background-color: var(--surface-neutral-pale);\n  font-family: inherit;\n  font-size: inherit;\n  text-align: left;\n  width: 100%;\n}\n\n.paymentOption:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n}\n\n.paymentOption.selected {\n  background-color: var(--surface-primary-subtle);\n}\n\n.paymentOption:disabled,\n.paymentOption.disabled {\n  cursor: not-allowed;\n  background-color: var(--surface-neutral-pale);\n}\n\n.paymentOption:hover:not(.selected):not(.disabled) {\n  background-color: var(--surface-primary-subtle);\n}\n\n.radioButton {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  border: 1px solid var(--icon-neutral-dark);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin: var(--spacing-0-5);\n}\n\n.selected .radioButton {\n  border-color: var(--surface-primary-medium);\n  background-color: var(--surface-primary-medium);\n}\n\n.radioSelected {\n  width: 6px;\n  height: 6px;\n  background-color: var(--surface-neutral-white);\n  border-radius: 50%;\n}\n\n.methodContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.methodTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: 24px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.disabled .methodTitle {\n  color: var(--disabled-subtle-text);\n}\n\n.methodDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: 16px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.disabled .methodDescription {\n  color: var(--disabled-subtle-text);\n}\n\n.disabled .methodIcon {\n  opacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentOption": `lHd0F5`,
	"selected": `ml9RUS`,
	"disabled": `nXShoN`,
	"radioButton": `csSp_z`,
	"radioSelected": `h_O154`,
	"methodContent": `UilNtv`,
	"methodTitle": `HPKBW7`,
	"methodDescription": `Sc4kYh`,
	"methodIcon": `iV92mG`
};
module.exports = ___CSS_LOADER_EXPORT___;
